import React from 'react';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { MdDelete } from "react-icons/md";
import { checkPermission } from '../../Utils/permissionHelper';

const DeleteButton = ({
    onDelete,
    permission = null,
    disabled = false,
    className = "text-secondary icon-color p-0",
    tooltipTitle = "Delete"
}) => {
    const handleClick = () => {
        if (onDelete) {
            onDelete();
        }
    };

    const isDisabled = disabled || (permission && !checkPermission(permission));

    return (
        <Tooltip
            title={tooltipTitle}
            className="btn btn-white"
            disabled={isDisabled}
        >
            <IconButton onClick={handleClick} disabled={isDisabled}>
                <MdDelete className={className} />
            </IconButton>
        </Tooltip>
    );
};

export default DeleteButton;
